import React from 'react';

import DiscoveryRelatedChannel from './DiscoveryRelatedChannel';
import DiscoveryRelatedProductList from '../sharedUnpackeNewsComponents/DiscoveryRelatedProductList';
import Footer from '../sharedUnpackeNewsComponents/Footer';
import I18n from '../../../lib/i18n';
import { IUnpackedMainContent } from '../../../models/MessagePreview/UnpackedMainContent';
import { IUnpackedRelatedChannel } from '../../../models/MessagePreview/UnpackedRelatedChannel';
import { IUnpackedRelatedMovie } from '../../../models/MessagePreview/UnpackedRelatedMovie';
import { IUnpackedRelatedProduct } from '../../../models/MessagePreview/UnpackedRelatedProduct';
import MainImage from '../sharedUnpackeNewsComponents/MainImage';
import MainText from '../sharedUnpackeNewsComponents/MainText';
import MoreLink from '../sharedUnpackeNewsComponents/MoreLink';
import RatingMultiRepresentation from '../sharedUnpackeNewsComponents/RatingMultiRepresentation';
import RelatedMovieList from '../sharedUnpackeNewsComponents/RelatedMovieList';
import Subject from '../sharedUnpackeNewsComponents/Subject';

interface IProps {
  subject: string;
  body: IUnpackedMainContent[];
  more: string;
  relatedProducts: IUnpackedRelatedProduct[];
  relatedMovies: IUnpackedRelatedMovie[];
  relatedChannel: IUnpackedRelatedChannel;
  footerText: string;
  ratingInformation: Array<{
    rating_icon: string;
    contents_descriptors: string;
    interactive_elements: string;
  }>;
}

const DiscoveryNewsBody = (props: IProps) => {
  const {
    subject,
    body,
    relatedProducts,
    more,
    relatedMovies,
    footerText,
    ratingInformation,
    relatedChannel,
  } = props;

  return(
    <div className="news-body">
      <Subject {...{ subject }} />
      { body.map((content, index) => {
        return(
          <div key={index}>
            <MainImage mainImage={content.main_image} movieUrl={content.movie_url} />
            <MainText mainText={content.text} tagSupported={true} />
          </div>
        );
      })}

      <MoreLink {...{ more }} />
      <DiscoveryRelatedProductList relatedProducts={relatedProducts}/>
      <DiscoveryRelatedChannel relatedChannel={relatedChannel}/>
      <RelatedMovieList {...{ relatedMovies }} />
      <div className="bookmark">{I18n.t('messages.show.bookmark')}</div>
      <Footer {...{ footerText }} />
      <RatingMultiRepresentation {...{ ratingInformation }} />
    </div>
  );
};

export default DiscoveryNewsBody;
